import api from '../../api/client';

export const MESI = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];
export const eur = (n) => (Number(n) || 0).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
export const dataIt = (d) => d ? new Date(d).toLocaleDateString('it-IT') : '';

export const inputS = { background:'var(--bg-input)',border:'1px solid var(--border2)',borderRadius:'8px',padding:'9px 12px',color:'var(--text)',fontSize:'var(--font-size-sm)',outline:'none',width:'100%',boxSizing:'border-box',fontFamily:'inherit' };
export const labelS = { fontSize:'var(--font-size-xs)',letterSpacing:'2px',fontWeight:'700',color:'var(--text-dim)',marginBottom:'6px',display:'block' };
export const btnPri = { background:'#F4600C',color:'#fff',border:'none',borderRadius:'8px',padding:'10px 18px',fontSize:'var(--font-size-xs)',fontWeight:'700',cursor:'pointer',letterSpacing:'1px' };
export const btnSec = { background:'transparent',color:'var(--text-dim)',border:'1px solid var(--border2)',borderRadius:'8px',padding:'9px 14px',fontSize:'var(--font-size-xs)',fontWeight:'700',cursor:'pointer',letterSpacing:'1px' };
export const card = { background:'var(--bg-card)',border:'1px solid var(--border)',borderRadius:'12px',padding:'18px' };
export const th = { textAlign:'left',fontSize:'var(--font-size-xs)',letterSpacing:'1.5px',fontWeight:'700',color:'var(--text-dim)',padding:'8px 10px',borderBottom:'1px solid var(--border)' };
export const td = { padding:'11px 10px',borderBottom:'1px solid var(--border)',verticalAlign:'top',fontSize:'var(--font-size-sm)' };

const STATI = {
  IN_ATTESA: { label:'IN ATTESA', color:'#F5A524' },
  APPROVATO: { label:'APPROVATO', color:'#3DBE7A' },
  RIFIUTATO: { label:'RIFIUTATO', color:'#EF5350' },
};
export const pillS = (stato) => {
  const c = (STATI[stato] || STATI.IN_ATTESA).color;
  return { background:`${c}22`, color:c, borderRadius:'10px', padding:'2px 9px', fontSize:'var(--font-size-xs)', fontWeight:'700', letterSpacing:'1px', whiteSpace:'nowrap' };
};
export const statoLabel = (s) => (STATI[s] || STATI.IN_ATTESA).label;

// Legge un file come base64 (senza prefisso data:) per l'upload JSON usato ovunque nel gestionale
export const leggiFile = (file) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve({ base64: String(r.result).split(',')[1], mime: file.type, nome: file.name });
  r.onerror = () => reject(new Error('Impossibile leggere il file'));
  r.readAsDataURL(file);
});

// Le API PDF sono autenticate: si scarica come blob e si apre in una nuova scheda
export const apriPdf = async (url) => {
  const win = window.open('', '_blank'); // aperta subito, altrimenti il popup blocker la blocca dopo l'await
  try {
    const r = await api.get(url, { responseType: 'blob' });
    const blobUrl = URL.createObjectURL(r.data);
    if (win) win.location.href = blobUrl; else window.location.href = blobUrl;
  } catch (e) {
    if (win) win.close();
    let msg = 'Errore nel generare il PDF';
    try { msg = JSON.parse(await e.response.data.text()).error || msg; } catch {}
    alert(msg);
  }
};
